const Video = () => (
  <svg viewBox="0 0 17 11" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.261 0c-.206 0-.412.081-.615.241l-2.923 2.31c-.47.37-.823 1.097-.823 1.69V6.76c0 .593.355 1.32.823 1.69l2.923 2.31c.204.16.41.241.615.241v-.002c.233 0 .444-.11.578-.301.106-.153.161-.35.161-.583V.884c0-.61-.37-.884-.739-.884zM9.775.046h-8.5C.572.046 0 .61 0 1.305v8.392c0 .694.572 1.259 1.275 1.259h8.5c.703 0 1.275-.565 1.275-1.259V1.305c0-.694-.572-1.26-1.275-1.26z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default Video
